import axios from 'axios';
// utils
import { API_BASE_URL } from '../utils/envVariables';
import { commonLogoutFunc, ExemptedEndpoints, getReduxData } from '../utils/share';

export const axiosInstance = axios.create({
  baseURL: `${API_BASE_URL}/api/`,
  crossDomain: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor
axiosInstance.interceptors.request.use(async (config) => {
  const isExempted = !!ExemptedEndpoints.find((item) => config.url.indexOf(item) !== -1);
  if (!isExempted) {
    try {
      const { jwtToken } = getReduxData();
      const token = jwtToken ? `${jwtToken}` : undefined;
      config.headers.Authorization = token;
      return config;
    } catch (error) {
      commonLogoutFunc();
      window.location.replace('/auth/login');
      return null;
    }
  } else return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.status === 'error') {
      return Promise.reject(response);
    }
    return response;
  },
  (error) => {
    if (error?.message === 'Request failed with status code 401') {
      commonLogoutFunc();
      window.location.replace('/auth/login');
    }
    return Promise.reject(error);
  }
);
